import PropTypes from 'prop-types'

export const CHANNELS = { EMAIL: 'email', SFTP: 'sftp' }

export const GENERATORS = {
  SECTION: 'section',
  ALERT: 'alert',
  OPERATOR: 'operator',
  RESOURCE: 'resource',
  COLLECT: 'collect'
}

export const CRON_SPECIAL = { INSTANT: 'instant', CUSTOM: 'custom' }

export const FREQUENCIES = { SPONTANEOUS: 'spontaneous', RECURRENT: 'recurrent' }

export const OUTPUT_FORMATS = { XLSX: 'xlsx', CSV: 'csv', PDF: 'pdf' }

export const DEFAULT_CRON = '0 7 * * *'

export const RECURRENCE_PRESETS = [
  { label: 'Journalier', value: '0 7 * * *', description: 'Envoi tous les jours à 7h' },
  { label: 'Hebdomadaire', value: '0 7 * * 1', description: 'Envoi chaque lundi à 7h' },
  { label: 'Mensuel', value: '0 7 1 * *', description: 'Envoi le 1er de chaque mois à 7h' },
  {
    label: 'Trimestriel',
    value: '0 7 1 1,4,7,10 *',
    description: 'Envoi le 1er janvier, avril, juillet, octobre à 7h'
  },
  { label: 'Semestriel', value: '0 7 1 1,7 *', description: 'Envoi le 1er janvier, juillet à 7h' },
  { label: 'Annuel', value: '0 7 1 1 *', description: 'Envoi le 1er janvier à 7h' },
  { label: 'Instantané', value: CRON_SPECIAL.INSTANT },
  { label: 'Personnalisé', value: CRON_SPECIAL.CUSTOM }
]

export const toSelectOptions = pairs => pairs.map(
  ([label, value]) => ({ label, value })
)

export const formOptionsPropType = PropTypes.shape({
  channels: PropTypes.arrayOf(PropTypes.string).isRequired,
  collectFrequency: PropTypes.string.isRequired,
  credentials: PropTypes.arrayOf(PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )),
  generators: PropTypes.arrayOf(PropTypes.arrayOf(
    PropTypes.string
  )).isRequired,
  recurrencePresets: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    description: PropTypes.string
  })).isRequired,
  sections: PropTypes.arrayOf(PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )).isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  })).isRequired,
  variables: PropTypes.arrayOf(PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )).isRequired
})
